export interface IndexLayerOption {
  names?: Record<string, string>;
  value?: string | null;
}

export const INDEX_LAYER_OPTIONS: IndexLayerOption[] = [
  {
    names: {
      'en-US': '',
      'fr-FR': '',
      'ru-RU': '',
      'ar-LB': '',
      'uz-Latn-UZ': '',
      'uz-Cyrl-UZ': '',
    },
    value: null
  },
  {
    names: {
      'en-US': 'ARVI',
      'fr-FR': 'ARVI',
      'ru-RU': 'ARVI',
      'ar-LB': 'ARVI',
      'uz-Latn-UZ': 'ARVI',
      'uz-Cyrl-UZ': 'ARVI',
    },
    value: 'Arvi'
  },
  {
    names: {
      'en-US': 'EVI',
      'fr-FR': 'EVI',
      'ru-RU': 'EVI',
      'ar-LB': 'EVI',
      'uz-Latn-UZ': 'EVI',
      'uz-Cyrl-UZ': 'EVI',
    },
    value: 'Evi'
  },
  {
    names: {
      'en-US': 'GNDVI',
      'fr-FR': 'GNDVI',
      'ru-RU': 'GNDVI',
      'ar-LB': 'GNDVI',
      'uz-Latn-UZ': 'GNDVI',
      'uz-Cyrl-UZ': 'GNDVI',
    },
    value: 'Gndvi'
  },
  {
    names: {
      'en-US': 'MNDWI',
      'fr-FR': 'MNDWI',
      'ru-RU': 'MNDWI',
      'ar-LB': 'MNDWI',
      'uz-Latn-UZ': 'MNDWI',
      'uz-Cyrl-UZ': 'MNDWI',
    },
    value: 'Mndwi'
  },
  {
    names: {
      'en-US': 'NDWI',
      'fr-FR': 'NDWI',
      'ru-RU': 'NDWI',
      'ar-LB': 'NDWI',
      'uz-Latn-UZ': 'NDWI',
      'uz-Cyrl-UZ': 'NDWI',
    },
    value: 'Ndwi'
  },
  {
    names: {
      'en-US': 'NDMI',
      'fr-FR': 'NDMI',
      'ru-RU': 'NDMI',
      'ar-LB': 'NDMI',
      'uz-Latn-UZ': 'NDMI',
      'uz-Cyrl-UZ': 'NDMI',
    },
    value: 'Ndmi'
  },
  {
    names: {
      'en-US': 'NDVI',
      'fr-FR': 'NDVI',
      'ru-RU': 'NDVI',
      'ar-LB': 'NDVI',
      'uz-Latn-UZ': 'NDVI',
      'uz-Cyrl-UZ': 'NDVI',
    },
    value: 'Ndvi'
  },
  {
    names: {
      'en-US': 'ORVI',
      'fr-FR': 'ORVI',
      'ru-RU': 'ORVI',
      'ar-LB': 'ORVI',
      'uz-Latn-UZ': 'ORVI',
      'uz-Cyrl-UZ': 'ORVI',
    },
    value: 'Orvi'
  },
  {
    names: {
      'en-US': 'OSAVI',
      'fr-FR': 'OSAVI',
      'ru-RU': 'OSAVI',
      'ar-LB': 'OSAVI',
      'uz-Latn-UZ': 'OSAVI',
      'uz-Cyrl-UZ': 'OSAVI',
    },
    value: 'Osavi'
  }
]
